import { AppRoute } from '@app/core/routing/AppRoute';
import { Redirect, Switch } from 'react-router-dom';
import { LivePlayerAdapterPage } from './LivePlayerAdapterPage';

/**
 * Routes for the live player module. Owns the /live-player path.
 * /live-player/:station shows the full-screen live player for the given station (slug).
 */
export function LivePlayerRoutes() {
  return (
    <Switch>
      <AppRoute path="/live-player/:station" component={LivePlayerAdapterPage} />
      <Redirect to="/logger" />
    </Switch>
  );
}
